export const defaultConsentActions = {
    loadDocuments: () => Promise.resolve(),
    loadAssignmentCatalog: () => Promise.resolve([]),
    hydrateDocument: () => Promise.resolve(undefined),
    addDocument: () => Promise.resolve(),
    updateDocument: () => Promise.resolve(),
    setActiveDocument: () => { },
    addElement: () => { },
    autoMapElements: () => { },
    updateElement: () => { },
    deleteElement: () => { },
    setSelectedElement: () => { },
    updateDocumentRoles: () => { },
    updateDocumentLanguage: () => { },
    updateDocumentDelayedSigning: () => { },
    updateDocumentName: () => { },
    updateDocumentDescription: () => { },
    updateDocumentCustomFields: () => { },
    updateDocumentScreens: () => { },
    updateDocumentSource: () => { },
    replaceDocumentSourceFile: () => Promise.resolve(),
    clearDocumentSourceFile: () => Promise.resolve(),
    saveDocumentToStorage: () => Promise.resolve(),
    uploadConsentFile: () => Promise.reject(new Error('ConsentProvider is not mounted')),
    archiveTemplateVersion: () => Promise.resolve(),
    getArchiveImpact: () => Promise.reject(new Error('ConsentProvider is not mounted')),
    cloneTemplateVersion: () => Promise.reject(new Error('ConsentProvider is not mounted')),
    deleteTemplateVersion: () => Promise.resolve(),
    fetchDocumentPdf: () => Promise.resolve(undefined),
    saveConsentTemplate: () => Promise.resolve(),
    publishConsentTemplate: () => Promise.resolve(),
    trackTemplatePublish: (_documentId, run) => run(),
};
